module.exports = __webpack_public_path__ + "img/8.c9b621c7.jpg";